"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _underscore = require("underscore");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _ContactProperties = require("lead-flows-ui/constants/ContactProperties");

var _ContactPropertyUtils = require("lead-flows-ui/utils/ContactPropertyUtils");

var ContactPropertyFieldType =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertyFieldType, _React$PureComponent);

  function ContactPropertyFieldType() {
    (0, _classCallCheck2.default)(this, ContactPropertyFieldType);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertyFieldType).apply(this, arguments));
  }

  (0, _createClass2.default)(ContactPropertyFieldType, [{
    key: "getOptions",
    value: function getOptions() {
      return (0, _underscore.map)(_ContactProperties.FieldTypeLabels, function (langKey, value) {
        return {
          text: _I18n.default.text(langKey),
          value: value
        };
      }).filter(function (value) {
        return (0, _ContactPropertyUtils.isPropertyAllowedInFlowsByValue)(value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          handleChange = _this$props.handleChange;
      return _react.default.createElement(_UISelect.default, {
        options: this.getOptions(),
        value: value,
        onChange: handleChange
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        value: _react.default.PropTypes.string.isRequired,
        handleChange: _react.default.PropTypes.func.isRequired
      };
    }
  }]);
  return ContactPropertyFieldType;
}(_react.default.PureComponent);

exports.default = ContactPropertyFieldType;
module.exports = exports.default;